export default __webpack_public_path__ + "static/create-new-action-light-mode-3a04232c23390deb9551cdea7b17f440.png";